<template src="./index.html"></template>

<script>
import {getdata} from "./data.js";
import { xxzzs_mxquery, xxzzs_ywlxquery,syncInvoiceInfo } from "../../../../../api/xxzzs.js";
import { Select } from "element-ui";
import config from "../../../../../../configHttp.js";
import { comMapping } from '@/components/util/Function/comMapping';
import { kydkpz_queryCompanyList } from '@/api/kydkpz';
import { deleteBatchAutoLog, queryGatewayInfo } from '@/api/organization';
import bsdl from '@/components/common/bsdl/index.vue';
export default {
  data: function () {
    return {
      shaidiag: false,
      headData: getdata().headData,
      outlist: [],
      searchdiag: false,
      searchlist: getdata().searchlist,
      dateValue: "",
      searchdata: getdata().searchdata,
      tableData: [],
      pagination: getdata().pagination,
      tablekey: 0,
	  overlength:0,
        businessTypeList:[],
        ywlxData: [],
        options:[],
        companyCode: "",
        logId: 0,
        drawer: false,
        rpaFormData:{},
        dialogFormVisible: false,
        syncForm: getdata().syncFormDefault,
        formLabelWidth: '120px',
        value1: '',
        invoiceType: [
            {
                label: "进项",
                value: "INPUT"
            },
            {
                label: "销项",
                value: "OUTPUT"
            }
        ],
        invoiceStatus: [
            {
                label: "全部",
                value: "ALL"
            },
            {
                label: "正常",
                value: "NORMAL"
            },
            {
                label: "已作废",
                value: "VOID"
            },
            {
                label: "部分红冲",
                value: "PARTIAL_RED"
            },
            {
                label: "全额红冲",
                value: "FULL_RED"
            }
        ],
    };
  },
  mounted() {
      this.loadHeadData()
  },
  components: { bsdl },
  methods: {
	  geOoverLength(e){
		  this.overlength = e;
		 
	  },
    fetchBillDetails() {
      let params = JSON.parse(JSON.stringify(this.searchdata));
      params.current = this.pagination.pageNum;
      params.size = this.pagination.pageSize;
      params.sort = "createTime";
      params.order = "desc";
      xxzzs_mxquery(params).then((res) => {
        this.pagination.total = res.data.data.total;
        this.pagination.paginationkey ++;
        this.tableData = res.data.data.records;
      });
      this.ywlxData = [{
          label: '电子专票',
          value: '028'
      },
          {
              label: '电子普票',
              value: '026'
          }, {
              label: '纸质普票',
              value: '007'
          },
          {
              label: '纸质专票',
              value: '004'
          }
      ]
    },
    closeshaidiag() {
      this.shaidiag = false;
    },
    confirmfilter(e) {
      this.headData = e.chooselist;
      this.outlist = e.nochooselist;
      this.shaidiag = false;
    },
    closeSearch() {
      this.searchdiag = false;
    },
    saveChange(e) {
      this.searchdiag = false;
    },
    forUpdateSearch() {
      this.searchdiag = true;
    },
      loadHeadData(){
          let params = { resRange:"1" };
          xxzzs_ywlxquery(params).then((res) => {
              if (res.data.code === "1"){
                  this.businessTypeList = res.data.data;
                  const hasBusinessType = this.searchlist.some(item => item.prop === "businessType");
                  if (!hasBusinessType) {
                      this.searchlist.push({
                          prop: "businessType",
                          label: '业务类型',
                          type: "select",
                          selectval: res.data.data
                      });
                  }
              } else {
                  this.searchlist.push({
                      prop: "businessType",
                      label: '业务类型',
                      type: "select",
                      selectval: []
                  });
              }
          });

          kydkpz_queryCompanyList().then(res => {
              if (res.data.code === 1) {
                  let _data = res.data.data.map(v => {
                      return {
                          value: v.id,
                          label: v.nsrmc
                      };
                  });
                  this.options.push(..._data);
              } else {
                  this.$message.error(res.data.msg);
              }
          });
      },
    outPutIInvResult() {
      let selectVal = this.$refs.tablebox.getSelectionval();
      let data = {};
      if (selectVal.length > 0) {
        data.ids = selectVal.map((item) => item.id);
      } else {
        data.fapiaoInfoSearchExtendInputDTO = JSON.parse(JSON.stringify(this.searchdata));
      }
      let params = {
        downUrl: config.baseURL + "oinv/details/export",
        typeObj: {
          toForm: false,
          fileName: "销项增值税票据明细" + this.$timestampToStr(new Date(), "yyyyMMdd"),
          fileType: "xlsx",
          failUrl:this.$winURl
        },
        params: data,
      };
      this.$downloadcommon(params);
    },
    forRefresh() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
      this.fetchBillDetails();
      this.loadHeadData();
    },
      syncData(){
          this.dialogFormVisible = true
      },
      submitSync() {
          if (!this.syncForm.issueDate || this.syncForm.issueDate.length === 0) {
              this.$message.error("请选择开票日期")
              return;
          }/*
          if (!this.syncForm.invoiceType) {
              this.$message.error("请选择发票类型")
              return;
          }*/
          if (!this.syncForm.invoiceStatus) {
              this.$message.error("请选择发票状态")
              return;
          }
          this.syncForm.issueStart = this.syncForm.issueDate[0];
          this.syncForm.issueEnd = this.syncForm.issueDate[1];
          this.syncForm.invoiceType = "OUTPUT";
          this.syncForm.step = 6; // 当前步骤
          let companyId = this.syncForm.companyId;
          syncInvoiceInfo(this.syncForm).then(res => {
              if (res.data.code === "1"){
                  this.$message.success("已提交同步任务，请稍后再进行查询")
              } else if (res.data.code === "102") {
                  // 需要登录
                  this.$confirm('同步失败，RPA未登录，点击确认进行登录', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning'
                  }).then(() => {
                      queryGatewayInfo({companyId: companyId}).then(gatewayRes => {
                          if (gatewayRes.data.code === 1) {
                              this.rpaFormData = gatewayRes.data.data[0];
                              this.drawer = true;
                              this.logId = res.data.data;
                          }
                      })
                  }).catch(()=>{
                      deleteBatchAutoLog({id: res.data.data}).then(autoLogRes=>{})
                  });
              } else {
                  this.$message.error("提交任务失败，原因：" + res.data.msg);
              }
              this.closedialog();
          })
      },
      closedialog() {
          this.dialogFormVisible = false;
          this.syncForm = getdata().syncFormDefault
      },
      smsClose() {
          this.drawer = false;
      },
    sizechange(e) {
      this.pagination.pageSize = e;
      this.fetchBillDetails();
    },
    currentChange(e) {
      this.pagination.pageNum = e;
      this.fetchBillDetails();
    },
    submitSearch() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
      this.fetchBillDetails();
    },
  },
  created() {
    this.fetchBillDetails();
  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
